module.exports = __webpack_public_path__ + "img/icon_honbao.0c932261.png";